module.exports = __webpack_public_path__ + "static/chimney-removal-banner-eeb7a7af65b8a944704043e83a897a8d.jpg";